import { GoToRoute } from "./../../../utils/go-to.util";
const master = [
  {
    label: "Organizações",
    labelEN: "Organizations",
    name: "organizations",
    icon: "md-businesscenter-outlined",
    command: () => go().redirectToPage("organizations"),
  },
  {
    label: "Usuários",
    labelEN: "Users",
    name: "users",
    icon: "md-personoutline-outlined",
    command: () => go().redirectToPage("users"),
  },
  {
    label: "Temas",
    labelEN: "Themes",
    name: "themes",
    icon: "md-personoutline-outlined",
    command: () => go().redirectToPage("themes"),
  },
];

const adm = [
  {
    label: "Cursos",
    labelEN: "Courses",
    name: "dashboardAdm",
    icon: "md-map-outlined",
    command: () => go().redirectToPage("dashboardAdm"),
  },
  {
    label: "Estatísticas",
    labelEN: "Stats",
    name: "stats",
    icon: "md-timeline-outlined",
    command: () => go().redirectToPage("stats"),
  },
  {
    label: "Usuários",
    labelEN: "Users",
    name: "users",
    icon: "md-personoutline-outlined",
    command: () => go().redirectToPage("users"),
  },
  {
    label: "Turmas",
    labelEN: "Classes",
    name: "classes",
    icon: "md-book-outlined",
    command: () => go().redirectToPage("classes"),
  },
  // {
  //   label: "Fórum",
  //   labelEN: "Forum",
  //   name: "listForums",
  //   icon: "md-forum-outlined",
  //   groupRouteFrom: "forum",
  //   command: () => go().redirectToPage("listForums"),
  // },
];

const teacher = [
  {
    label: "Cursos",
    labelEN: "Courses",
    name: "dashboardTeacher",
    icon: "md-map-outlined",
    command: () => go().redirectToPage("dashboardTeacher"),
  },
  {
    label: "Estatísticas",
    labelEN: "Stats",
    name: "stats",
    icon: "md-timeline-outlined",
    command: () => go().redirectToPage("stats"),
  },
  {
    label: "Fórum",
    labelEN: "Forum",
    name: "listForums",
    icon: "md-forum-outlined",
    groupRouteFrom: "forum",
    command: () => go().redirectToPage("listForums"),
  },
  {
    label:"Turmas",
    labelEN:"Classes",
    name:"classes",
    icon:"md-class-outlined",
    groupRouteFrom:"classes",
    command:()=>go().redirectToPage("classes")
  },
  {
    label:"Calendário",
    labelEN:"Calendar",
    name:"calendar",
    icon:"bi-calendar-event",
    command:()=>go().redirectToPage("calendar")
  }
];

const student = [
  {
    label: "Meus Cursos",
    labelEN: "My Courses",
    name: "dashboardStd",
    icon: "md-map-outlined",
    command: () => go().redirectToPage("dashboardStd"),
  },
  {
    label: "Solicitar suporte",
    labelEN: "Request support",
    name: "faq",
    icon: "md-contactsupport-outlined",
    command: () => go().redirectToPage("faq"),
  },
];

function go(): GoToRoute {
  return new GoToRoute();
}

export { adm, master, student, teacher };
